export default __webpack_public_path__ + "static/media/7.2b2460da.png";